import { isDevelopment } from "./Helpers";

let apiUrl: string = "https://api.dev.wistron.eu/sfcsf6h2/API.SFC.Internal/api/SFCSDynamicProcess";

if (!isDevelopment) {
    apiUrl = "https://api.wistron.eu/sfcsf6h2/API.SFC.Internal/api/SFCSDynamicProcess";
}

//export microservices base URL
export { apiUrl }